import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useCompany } from "@/context/CompanyContext";

const DEFAULTS = { tile1: "#1d4ed8", tile2: "#059669", tile3: "#7c3aed", tile4: "#d97706", tile5: "#e11d48" };

// Effective dashboard tile colors: bureau defaults overridden by the active client's brand palette.
export function useTileColors(companyId) {
  const { user } = useAuth();
  const { activeCompanyId } = useCompany();
  const cid = companyId !== undefined ? companyId : user?.role === "bureau_admin" ? activeCompanyId : undefined;
  const [colors, setColors] = useState(DEFAULTS);
  useEffect(() => { api.get("/tile-colors", { params: cid ? { company_id: cid } : {} }).then((r) => setColors({ ...DEFAULTS, ...r.data.effective })).catch(() => {}); }, [cid]);
  return colors;
}
